import { View, ViewProps } from "react-native";
import React from "react";
import tailshake from "tailshake";

const Container: React.FC<ViewProps> = (props) => {
  const { children, className, ...rest } = props;
  return (
    <View
      className={tailshake("max-w-7xl px-4 w-full mx-auto", className)}
      {...rest}
    >
      {children}
    </View>
  );
};

export default Container;
